import { proposalsApi } from 'app/src/services/welfareportal'
import { AttachmentList } from 'app/src/shared/components/AttachmentList'
import { useTranslation } from 'react-i18next'

export function InstructionLinkSection() {
  const { t } = useTranslation('proposal', { keyPrefix: 'Proposal.InstructionLinkSection' })

  const documentListMutation = proposalsApi.useDocumentList({})

  const documents = documentListMutation.data?.items
  return (
    documents &&
    documents.length > 0 &&
    documents.filter((el) => el.type === 'pdf').length > 0 && (
      <AttachmentList
        attachments={documents
          .filter((el) => el.type === 'pdf')
          .map((d) => ({
            id: d.documentId!,
            name: d.name!,
            resourceLink: d.url,
            type: d.type!,
          }))}
        title={t('Title')}
      />
    )
  )
}
